const boycottList = [
  {
    id: "aero",
    logo: "https://www.nestle.com/sites/default/files/styles/thumbnail/public/asset-library/publishingimages/brands/chocolate-confectionery/aero-logo-round.png",
    name: "Aero",
  },

  {
    id: "agoda",
    logo: "https://www.bookingholdings.com/wp-content/uploads/2019/10/bkng_brands-fullyopen-agoda-1.svg",
    name: "Agoda",
  },

  {
    id: "airbnb",
    logo: "https://s.yimg.com/uu/api/res/1.2/Bz8iDlw16Zf6PVc.y33xdg--~B/aD0zOTA7dz02MTA7YXBwaWQ9eXRhY2h5b24-/http://globalfinance.zenfs.com/Finance/US_AHTTP_ENTREPRENEUR_H_NEW_LIVE/1405612741-airbnb-why-new-logo_original.jpg",
    name: "Airbnb",
  },
  {
    id: "americaneagle",
    logo: "https://logowik.com/content/uploads/images/american-eagle-outfitters7114.jpg",
    name: "American Eagle",
  },

  {
    id: "aquafina",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/072017/untitled-4_4.png",
    name: "Aquafina",
  },

  {
    id: "booking",
    logo: "https://www.bookingholdings.com/wp-content/uploads/2020/11/bkng_brands-fullyopen-booking.com_-1.svg",
    name: "Booking.com",
  },

  {
    id: "burgerking",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Burger_King_logo_%281994%29.svg/2111px-Burger_King_logo_%281994%29.svg.png",
    name: "Burger King",
  },
  {
    id: "buxton",
    logo: "https://www.nestle.com/sites/default/files/styles/thumbnail/public/buxton-logo-round.png",
    name: "Buxton",
  },

  {
    id: "carrefour",
    logo: "https://assets.stickpng.com/images/5842906ca6515b1e0ad75abb.png",
    name: "Carrefour",
  },

  {
    id: "chanel",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/102013/chanel_black.png",
    name: "Chanel",
  },
  {
    id: "cheapflights",
    logo: "https://www.cheapflights.co.uk/news/wp-content/uploads/sites/138/2020/03/default-post-thumbnail-1640x1312.png",
    name: "Cheapflights",
  },

  {
    id: "cheetos",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0010/0838/brand.gif",
    name: "Cheetos",
  },

  {
    id: "cocacola",
    logo: "https://www.coca-colacompany.com/content/dam/company/us/en/brands/logos/coca-cola-logo.png",
    name: "Coca-Cola",
  },
  {
    id: "coffeemate",
    logo: "https://www.nestle.com/sites/default/files/styles/thumbnail/public/coffee-mate-logo-round_7.png",
    name: "Coffee Mate",
  },

  {
    id: "costacoffee",
    logo: "https://www.coca-colacompany.com/content/dam/company/us/en/brands/logos/costa-logo.png",
    name: "Costa Coffee",
  },

  {
    id: "dasani",
    logo: "https://www.coca-colacompany.com/content/dam/company/us/en/brands/logos/dasani-logo.png",
    name: "Dasani Water",
  },
  {
    id: "diesel",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0012/4528/brand.gif",
    name: "Diesel Frangrances",
  },
  {
    id: "dietcoke",
    logo: "https://www.coca-colacompany.com/content/dam/company/us/en/brands/logos/dietCoke_transparency.png",
    name: "Diet Coke",
  },
  //   1

  {
    id: "dior",
    logo: "https://dynl.mktgcdn.com/p/KfI5g-nDtylqhtl1RdhWzG0DMJ7sGl0lGfr3EARlPtQ/500x500.jpg",
    name: "Dior / Christian Dior",
  },
  {
    id: "disney",
    logo: "https://www.trustedreviews.com/wp-content/uploads/sites/54/2022/02/Disney-Plus-logo-920x518.jpg",
    name: "Disney",
  },
  {
    id: "doritos",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0019/5529/brand.gif",
    name: "Doritos",
  },

  {
    id: "fanta",
    logo: "https://www.coca-colacompany.com/content/dam/company/us/en/brands/logos/fanta-logo.png",
    name: "Fanta",
  },

  {
    id: "fiverr",
    logo: "https://mms.businesswire.com/media/20230510006090/en/827135/22/Fiverr_September_2020_Logo.jpg",
    name: "Fiverr",
  },

  {
    id: "hp",
    logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQMAAADDCAMAAACxkIT5AAAAe1BMVEX///8AAABhYWFAQED6+vr19fXv7++Xl5f7+/tkZGTs7OzPz8/y8vK/v7/39/esrKyRkZHg4ODm5ubY2Ng4ODh9fX2CgoJNTU2Li4vHx8dwcHAzMzOwsLAaGhp2dnZbW1ssLCyenp4fHx8TExNUVFQjIyNDQ0O5ubmjo6OD7WlqAAAHn0lEQVR4nO2caUPqOhCGTxFEkEU2ERTZxf//C68cyeRtM0kKF+2EM88321A702QyW/vnj6IoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoiqIoN0hj3lq25pPnp/7joFP1zVTEIbMsPt7fBlXf0K/Q6Dbhr2VW5L3bqOzefofZPMtABx1HBUdas+pu8KfpNBdHEYf2yCergyzbNu+ru80fZDj5lm8Kx+48OjiuiaH3SqnSmRjh3uzBgV8FRy3c1lyoN61odXv4JaiDLHvqVXfL12a2t3LN4fgqooNscyvWsT5HsUCqx5gKvmjdxFR4XKBMe1gK7yV0kG1vYCo08yI9w6kyKvjiqbJ7vw71WkGgkT13YCVmWCa9HjrjgjgbOFlUj5/XhHfJ4aIozdqebJdWwZdRSDaWYlygtj3r85N5Rv5/I5mhK8kOTgf8ZI4kZwKjAvSTudO3poSGYwu+gNTA07k62KaXZ/pgxGjB+aif7DB+qEyYy5hzUpzpJ4dUmAC80YcBE3ZAhLX3/wlkxIrwYgfUL1FBlj1WJ9K5PLyyEsAe371MB6t0vOZnVoAxjHDzyeV4r0ymM+FXAq7m+wtVkM5q8HiA4Cf3L9bBa3VinYMnEMB88vRiHaSxN/Q8N186nxwhBXfR5wR34kNK8ez/11JoeG4d88kfd4ZijuUrLLAnka0dIT+h0nSk+qYLY6zj/9B4bOXHNd1LHmmMaMN94UfIoceFi0f8P8mHDv4S29B4XtItwptHBaFVjEqYBsaZ7Fv/2jd9ZXgvOZILA7/yLTTupOD9dW/52vh2vXHZX9WDA8sotHJ8VVSPpTPQuEiK4ORbTa53wz+ALzsElq53fwJ+RuMgy/JwAmfGaQ/Zh2dLtXiiJbbvYgXHzLiNFW6wH//ldQnjjI8tOXLyOYCcn9xkjsEkJzuJAYI5JtlF8MVCMHfJh+Lakqyx65FjCOEmbaJ3vyDLhfgyZGjpjHeMO4VRHVQjqSBbg3E2CSk3nzTz6AAsHVkMbnnAtN+ZY7D0ISJFz1sWa14FG3hq9Ci5MNIuD6pCLeDykISM7LUV4skS4nZujuHyMEsfqpHkZ6CwEF2FXOpq2fA64PLJMJnJ0sHyIIsIlhOTkNufF+Yy+M7b3HSmRwl1M2pLsjsAGRYsVOeSkLBbiCKeT6a+C1getAvC8qBFhbYvF45JDRk8NUSYzn1GBGZ52BYVuHq+WC+1W41vssLpbByBFRyj5WEPkR+F/mDeBw3G2BWyZnXA9V2AtSdLB1kW+i32XeQzE1I3Rz5whviQni/IxiwPWlO4AxaMjdTsMltPR0fA7J0om3m84DvT6jj4Ly618Mj23nKOACQEmTDS+gEYFRQui6l6SbA6gPP0KEE2xk+mKBL9y2KxPiUdwLolRwBDQbMUIBqmugv6AMWmVqk64OwByEHOX3h5kPHDJIHT1CrVHjD7AmYJzKNcQEaF1Ga79mg2YRnBKdZL3RfWrg5gG6foPxxG2nolJl2dBJXUhn7GT+T8ZMiKMH4yFapwxbtNrVJrTW688AFnzaPEKpGJjWB50BPH3LFbyJUaL7hxIzwtzk9mwkjyF3IZAreQKzVudFsPuP7kcBhJKfVPuDATkErNHzh5JK4/mWtLgiwLK6S76YrNIzmODDgCtE7Cy4PMKqqP6WmQm09c52+UdQRgx2OWB6XU0eYxTa1SQ2envgCOwAPnJ7thJM2M3FwvdOsUZpgwCnUmLmHGte/bLAubUuea/QR/JyLnzqEjwCTMuHILV2TkmloF1xvzvgz3vQvMJxtLZ4vrNFuw3s69ESO57pzzks7PJ88++3/5RA+Ia++R3H+AfShc3wV2XNPyiDSVMA2PG8l9KBg+R/LJZOliUTDT6Sa7HwkmLpjuYD45Mq+54pXopQBPDR0Bkx1Dc24s3SpyQaaWvYj8pGoo/D8/nxy+HvAZ/knlNE5b/BZyxxQLcssj/Akg9oUX8Y3rpyAAd3Bz75gHNRvIR/H3QH3ENnVIdg6+OblD01bNQHHQnT1GwsHyaO9qOZZ7V/4jYlMHlthHj7wC+d58KCB7Y/zG9yILC6YJfG8+FBBvDY6sz9ABl2UJIzdzkMP3DgMD/KrcW+CrimQ6l/Lv9cParnssYAGpOXWHUh/AOsJVI4NILbW69Mo901wYyX40oshGbp+yQ8nVAEXDch9EEB4s5Sm310MY6XsfLkcie4KByQU7YBhZ5i3wmve/yaReYoPkyi0BEvoIxokSn3mAMHJdQgdJOIh5oi/449Qu8eEwqZXmIDHn9zw/OUkVxCRbcFkWL0ntikhwOWBG5VZnwZF24Kto8GRjfvI+gbSJn97OKxiMivjJU8EV1lKUeAs8so3Kzx9G8Ux0yCeH/eRkouUQDc5vxmqkf71k2VL6hz/K0nVThZhP9mtge/BfNDV6jlUAS7/2quA5dWOYp523/dhk4Yuu5knviCwD1ELcT54n+B3dErTt63lwlPWTX25vDhDd7zZO7Npz7WWtm9oXdM+kc5gH/eT54VZ2wzAjeM7gPIxb/YRjo//BdLerzScv69nghk2AoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKoiiKovyb/AdZ9lL6MpgBeQAAAABJRU5ErkJggg==",
    name: "HP",
  },
  {
    id: "hsbc",
    logo: "https://www.hsbc.co.uk/etc.clientlibs/dpws/clientlibs-public/clientlib-site/resources/social/logo/Square-1200x1200px.jpg",
    name: "HSBC",
  },

  {
    id: "hyundai",
    logo: "https://pbs.twimg.com/profile_images/821433960639008768/_M06NaeP_400x400.jpg",
    name: "Hyundai",
  },

  {
    id: "itcosmetics",
    logo: "https://crueltyfree.peta.org/wp-content/uploads/it-cosmetics-logo.jpg",
    name: "IT Cosmetics",
  },

  {
    id: "kitkat",
    logo: "https://www.nestle.com/sites/default/files/styles/thumbnail/public/kitkat-logo-square-2023.png",
    name: "KitKat",
  },

  {
    id: "lion",
    logo: "https://www.nestle.com/sites/default/files/styles/thumbnail/public/cereals-lion-logo.png",
    name: "Lion",
  },
  {
    id: "lipton",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/012023/lipton.png?fbRyRvf2gy6O8JQcQhfxkr8O.CxRGBk.&itok=uZ6IQzoY",
    name: "Lipton",
  },
  // 3

  {
    id: "loreal",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0000/2125/brand.gif",
    name: "Loreal / L'oreal",
  },

  {
    id: "maccosmetics",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/122019/logo-mac_prancheta_1.png?NPZfS4QSWg_6ySGSJKInsSXz2CFRKvhS&itok=2_JpKro7",
    name: "MAC Cosmetics",
  },
  {
    id: "maggi",
    logo: "https://www.nestle.com/sites/default/files/styles/thumbnail/public/maggi-logo-round-2022.png",
    name: "Maggi",
  },

  {
    id: "mcdonalds",
    logo: "https://1000logos.net/wp-content/uploads/2017/03/McDonalds-logo-500x281.png",
    name: "McDonalds",
  },

  {
    id: "motorola",
    logo: "https://cdn.lovesavingsgroup.com/logos/motorola.jpg",
    name: "Motorola",
  },
  {
    id: "mountaindew",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0009/3885/brand.gif",
    name: "Mountain Dew",
  },

  {
    id: "nescafe",
    logo: "https://www.nestle.com/sites/default/files/styles/thumbnail/public/nescafe-logo-square.png",
    name: "Nescafe",
  },
  {
    id: "nespresso",
    logo: "https://www.nestle.com/sites/default/files/styles/thumbnail/public/nespresso-logo-round-2.png",
    name: "Nespresso",
  },
  {
    id: "nesquik",
    logo: "https://www.nestle.com/sites/default/files/styles/thumbnail/public/nesquik-logo-round-2021.png",
    name: "Nesquik",
  },
  {
    id: "nestle",
    logo: "https://cdn.worldvectorlogo.com/logos/nestle-5.svg",
    name: "Nestle",
  },

  {
    id: "pepsi",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0021/0128/brand.gif",
    name: "Pepsi",
  },

  {
    id: "puma",
    logo: "https://staticg.sportskeeda.com/editor/2023/03/bda84-16779522739911-1920.jpg",
    name: "Puma",
  },
  {
    id: "purelife",
    logo: "https://www.nestle.com/sites/default/files/styles/thumbnail/public/pure-life-logo-square.png",
    name: "Pure Life",
  },
  // 4

  {
    id: "rockstar",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0025/2387/brand.gif",
    name: "Rockstar Energy",
  },

  {
    id: "schweppes",
    logo: "https://www.coca-colacompany.com/content/dam/company/us/en/brands/logos/schweppes-logo.png",
    name: "Schweppes",
  },

  {
    id: "sprite",
    logo: "https://www.coca-colacompany.com/content/dam/company/us/en/brands/logos/sprite-logo.png",
    name: "Sprite",
  },

  {
    id: "starbucks",
    logo: "https://www.tailorbrands.com/wp-content/uploads/2020/11/starbucks-logo-2011.jpg",
    name: "Starbucks",
  },
  {
    id: "stella",
    logo: "https://r.lvmh-static.com/uploads/2022/08/stella-logo.png",
    name: "STELLA by Stella McCartney",
  },

  {
    id: "tomfordbeauty",
    logo: "https://media.licdn.com/dms/image/D4E0BAQH9tPiLt38cxA/company-logo_200_200/0/1695305566079?e=2147483647&v=beta&t=er2z4E0XEEsougatDEiiqIlaKhIJ4JnbpT2yTPKZqbM",
    name: "Tom Ford Beauty",
  },
  {
    id: "tropicana",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0017/4978/brand.gif",
    name: "Tropicana",
  },

  {
    id: "viber",
    logo: "https://cdn-icons-png.flaticon.com/512/124/124016.png",
    name: "Viber",
  },

  {
    id: "volvo",
    logo: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/052018/untitled-4_19.png?Nrpk5Y1UlrEvEEOMK6vQRsPrg_u.VN8O&itok=wHARdQlD",
    name: "Volvo",
  },

  {
    id: "wix",
    logo: "https://cdn-icons-png.flaticon.com/512/5968/5968762.png",
    name: "Wix",
  },
];

export default boycottList;
